import { getElementCoordinates, getIntAttribute } from './dom-util';

const HINT_OUTLINE_WIDTH = 15;
const HINT_PRIMARY_COLOR = 'white';
const HINT_OUTLINE_COLOR = 'RGB(40, 120, 193)';
const HINT_SHADOW_COLOR = 'RGBA(0, 0, 0, 0.5)';

const FOUND_SHADOW_COLOR = 'white';
const FOUND_SHADOW_WIDTH = 3;
const TRANSITION_STYLE = 'all .2s ease-in';

const HINT_OULTINE_STYLE = `outline: ${HINT_OUTLINE_WIDTH}px solid ${HINT_PRIMARY_COLOR}; outline-offset: ${HINT_OUTLINE_WIDTH}px; border-radius: 50%;`;

const FOUND_DROP_SHADOW_STYLE = `
    drop-shadow(${FOUND_SHADOW_WIDTH}px -${FOUND_SHADOW_WIDTH}px 1px ${FOUND_SHADOW_COLOR}) 
    drop-shadow(-${FOUND_SHADOW_WIDTH}px ${FOUND_SHADOW_WIDTH}px 1px ${FOUND_SHADOW_COLOR}) 
    drop-shadow(${FOUND_SHADOW_WIDTH}px ${FOUND_SHADOW_WIDTH}px 1px ${FOUND_SHADOW_COLOR}) 
    drop-shadow(-${FOUND_SHADOW_WIDTH}px -${FOUND_SHADOW_WIDTH}px 1px ${FOUND_SHADOW_COLOR})
`;

export const FOUND_OBJECT_STYLE = `filter: grayscale(1) ${FOUND_DROP_SHADOW_STYLE}; opacity: 60%; transition: ${TRANSITION_STYLE}; pointer-events: bounding-box;`;
export const HINT_OBJECT_STYLE = `${HINT_OULTINE_STYLE} transition:${TRANSITION_STYLE}; pointer-events: none`;

export const HINT_CIRCLE_BORDER_OFFSET = 40;
export const HINT_CIRCLE_STYLES = {
  border: `8px solid ${HINT_PRIMARY_COLOR}`,
  borderRadius: '50%',
  boxShadow: `0 0 0 4px ${HINT_OUTLINE_COLOR}, 0 2px 16px 2px ${HINT_SHADOW_COLOR}`,
  transition: TRANSITION_STYLE,
};

export const HINT_CIRCLE_CLASS_NAME = 'hint';

export const MIN_HITBOX_SIZE = 80;

export const buildHintCircle = (elem, parent: HTMLElement | null, scaleFactor) => {
  if (!parent) return;

  const circle = document.createElement('div');

  const { x, y } = getElementCoordinates(elem);
  const width = getIntAttribute(elem, 'width');
  const height = getIntAttribute(elem, 'height');

  circle.style.width = `${width / scaleFactor + HINT_CIRCLE_BORDER_OFFSET}px`;
  circle.style.height = `${height / scaleFactor + HINT_CIRCLE_BORDER_OFFSET}px`;

  circle.style.position = 'absolute';

  circle.style.top = `${y / scaleFactor - HINT_CIRCLE_BORDER_OFFSET / 2}px`;
  circle.style.left = `${x / scaleFactor - HINT_CIRCLE_BORDER_OFFSET / 2}px`;

  Object.assign(circle.style, HINT_CIRCLE_STYLES);

  circle.classList.add(HINT_CIRCLE_CLASS_NAME);

  parent.appendChild(circle);
};

export const removeHints = (parent: HTMLElement | null) => {
  if (!parent) return;

  parent
    .querySelectorAll(`.${HINT_CIRCLE_CLASS_NAME}`)
    .forEach((element) => parent.removeChild(element));
};
